var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Select } from 'ui/styled';
import enumCollections from 'constants/enumCollections';
var ClaimCategoriesSelect = function (props) {
    var _a;
    var sources = ((_a = enumCollections === null || enumCollections === void 0 ? void 0 : enumCollections.BILL_CLAIM_CATEGORY) === null || _a === void 0 ? void 0 : _a.enumValues) || [];
    var options = sources.map(function (_a) {
        var name = _a.name, description = _a.description;
        return ({
            label: description,
            value: name
        });
    });
    return _jsx(Select, __assign({}, props, { options: options, "data-test": "claimCategorySelect" }));
};
export default ClaimCategoriesSelect;
